// CDV-020: render a `table` block.

interface Props { //@usedby:ComposedBody.tsx
  columns: string[]
  rows: (string | number | null)[][]
  caption?: string
}

export function TableBlockView({ columns, rows, caption }: Props) {
  return (
    <div className="space-y-2">
      {caption ? (
        <div className="text-sm text-foreground-muted">{caption}</div>
      ) : null}
      <div className="overflow-x-auto rounded-lg border border-border">
        <table className="w-full text-sm">
          <thead className="bg-muted text-foreground-muted text-xs uppercase tracking-wider">
            <tr>
              {columns.map((c, i) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: header columns are positional and stable
                <th key={i} className={cellClass(c)} scope="col">
                  {c}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {rows.map((row, r) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: rows are positional and stable
              <tr key={r} className="hover:bg-muted/50">
                {columns.map((_, c) => {
                  // Missing cells (row shorter than columns) render as empty;
                  // extra cells (row longer than columns) are dropped silently
                  // — same defensive behaviour CDV-020 mandates.
                  const cell = c < row.length ? row[c] : null
                  return (
                    <td
                      // biome-ignore lint/suspicious/noArrayIndexKey: cells are positional
                      key={c}
                      className={cellClass(cell)}
                    >
                      {renderCell(cell)}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function renderCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '—'
  return String(value)
}

function cellClass(value: unknown): string {
  const numeric = typeof value === 'number'
  return [
    'px-3 py-2 align-top',
    numeric ? 'text-right tabular-nums' : 'text-left',
  ].join(' ')
}
